// Polyfill crypto.randomUUID for insecure (HTTP) contexts
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  crypto.randomUUID = () => {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    );
  };
}

// Pre-warm camera immediately — getUserMedia starts during splash screen,
// parallelized with JS bundle parse + Firebase auth. Consumed by useLocalCamera.
// Skip for playground/non-camera routes (no camera needed → don't activate hardware).
if (navigator.mediaDevices?.getUserMedia && window.location.pathname !== '/playground') {
  window.__earlyCameraPromise = navigator.mediaDevices.getUserMedia({
    video: { facingMode: 'environment', width: { ideal: 1280 }, height: { ideal: 720 } },
    audio: false,
  }).catch((err) => {
    console.warn('[pre-warm] getUserMedia failed:', err);
    return null;
  });
}

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import VConsole from 'vconsole'
import './index.css'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary'

// Mobile debug console — tap the green button to open
if (import.meta.env.DEV) {
  new VConsole();
}

// Benchmark harness SSE capture shim (#1133) — dev-only dynamic import so
// Vite constant-folds the branch and tree-shakes the module out of prod
// bundles. The shim is a no-op unless `window.__benchmarkMode === true`,
// but keeping it out of prod entirely eliminates the fetch monkey-patch
// surface and the "shim file shipped to real users" footgun.
if (import.meta.env.DEV) {
  await import('./utils/benchmarkCapture');
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)

// Remove splash screen after React mounts — fast fade since camera is starting behind it
const splash = document.getElementById('splash')
if (splash) {
  splash.classList.add('hide')
  setTimeout(() => splash.remove(), 250)
}
